import React from "react";

const SettingsSlidersStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.3999 5H4.3999",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.80005 5H14",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.3999 11.4H8.3999",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8 11.4H14",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.60005 6.79995C7.59416 6.79995 8.40005 5.99406 8.40005 4.99995C8.40005 4.00584 7.59416 3.19995 6.60005 3.19995C5.60594 3.19995 4.80005 4.00584 4.80005 4.99995C4.80005 5.99406 5.60594 6.79995 6.60005 6.79995Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6 13.2C11.5942 13.2 12.4 12.3941 12.4 11.4C12.4 10.4059 11.5942 9.59998 10.6 9.59998C9.60594 9.59998 8.80005 10.4059 8.80005 11.4C8.80005 12.3941 9.60594 13.2 10.6 13.2Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SettingsSlidersStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;